export function terminaisInRequest(params = {}) {
  return {
    type: '@terminal/TERMINAIS_IN_REQUEST',
    payload: { params },
  };
}

export function findTerminal(id) {
  return {
    type: '@terminal/FIND_TERMINAL',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@terminal/FAILED_REQUEST',
  };
}

export function deleteTerminal(idterminal, params) {
  return {
    type: '@terminal/DELETE_TERMINAL',
    payload: { idterminal, params },
  };
}

export function updateTerminal(terminal, params) {
  return {
    type: '@terminal/UPDATE_TERMINAL',
    payload: { terminal, params },
  };
}

export function storeTerminal(terminal, params) {
  return {
    type: '@terminal/STORE_TERMINAL',
    payload: { terminal, params },
  };
}

export function successInRequest(
  terminais,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@terminal/SUCCESS_IN_REQUEST',
    payload: { terminais, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(terminal) {
  return {
    type: '@terminal/SUCCESS_REQUEST',
    payload: { terminal },
  };
}

export function successRemove(params) {
  return {
    type: '@terminal/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@terminal/RECORD_FILTERING',
    payload: { params },
  };
}
